import { useaxios } from "../../../utils/useaxios";
export default (statment_number) => {
    return useaxios('statment/read.php', { statment_number }).then((res) => {
        return res;
    });
}